import { VariableConfig } from './types';

export const COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#ff7300', '#387908', '#0088fe', '#00c49f'];

export const MODELS = ['ECMWF', 'GFS', 'ICON', 'ACCESS'];

// Fixed color mapping for all models - colors will never change regardless of order
export const MODEL_COLORS: Record<string, string> = {
  // Jua Models - Distinct colors for easy differentiation
  'EPT-1.5': '#E34290', // Jua signature pink
  'EPT-1.5 Early': '#7C2D12', // Brown
  'EPT-2': '#8B5CF6', // Indigo
  'EPT-2 Early': '#DC2626', // Red
  'EPT-2 Reasoning': '#2563EB', // Bright blue
  'EPT-2e': '#06B6D4', // Cyan
  'EPT-2 RR': '#7C3AED', // Purple

  // ECMWF Models - Blue family
  ECMWF: '#0088FE', // Bright blue
  'EC AIFS': '#0066CC', // Medium blue
  'EC AIFS (Post-processed)': '#003D82', // Dark blue
  'ECMWF Ensemble Mean': '#4A90E2', // Light blue

  // GFS Models - Green family
  GFS: '#82CA9D', // Light green
  'GFS Ensemble Mean': '#387908', // Dark green
  'GFS Graphcast': '#10B981', // Emerald green

  // ICON Models - Orange family
  'ICON-EU': '#FF7300', // Orange
  'ICON Global': '#F59E0B', // Amber

  // Other Models - Various colors
  'Microsoft Aurora': '#8884D8', // Light purple
  UKMO: '#FFC658', // Yellow
  ACCESS: '#00C49F', // Teal
  'Météo-France': '#EF4444', // Red

  // Alternative naming patterns (in case series names vary)
  ept1_5: '#E34290',
  ept1_5_early: '#7C2D12',
  ept2: '#8B5CF6',
  ept2_early: '#DC2626',
  ept2_reasoning: '#2563EB',
  ept2_e: '#06B6D4',
  ept2_rr: '#7C3AED',
  ecmwf_ifs025_single: '#0088FE',
  ecmwf_ifs025_ensemble: '#4A90E2',
  ecmwf_aifs025_single: '#003D82',
  gfs_global_ensemble: '#387908',
  gfs_graphcast025: '#10B981',
  icon_eu: '#FF7300',
  icon_global: '#F59E0B',
  aurora: '#8884D8',
  aifs: '#0066CC',
};

// Mapping from dashboard variable types to API variable IDs
export const DASHBOARD_TO_API_VARIABLE_MAP = {
  wind: '100si', // Wind Speed 100m [m s⁻¹]
  solar: 'ssrd', // Surface Solar Radiation Downwards [J m⁻²]
  temperature: '2t', // Air Temperature 2m [°C]
} as const;

export const VARIABLE_CONFIG: Record<string, VariableConfig> = {
  wind: {
    title: 'Wind Forecast Models',
    yAxisName: 'Wind Speed (m/s)',
    unit: 'm/s',
    baseValue: 15,
    range: [0, 30],
    filename: 'wind-forecast-chart',
  },
  solar: {
    title: 'Solar Forecast Models',
    yAxisName: 'Solar Radiation (kJ/m²)',
    unit: 'kJ/m²',
    baseValue: 15000,
    range: [0, 35000],
    filename: 'solar-forecast-chart',
  },
  temperature: {
    title: 'Temperature Forecast Models',
    yAxisName: 'Temperature (°C)',
    unit: '°C',
    baseValue: 15,
    range: [-10, 40],
    filename: 'temperature-forecast-chart',
  },
};
